<template>
    <div class="safe-root">
        <Top></Top>
        <div class="safe-body___1UbSf">
            <div class="side-menu-layout">
                <div class="content_menu">
                    <div class="menu___aQSZq">
                        <ul class="ant-menu kc-menu  ant-menu-light ant-menu-root ant-menu-inline">
                            <li class="ant-menu-item" :class="active == 'my' ? 'ant-menu-item-selected' : ''" style="padding-left: 16px;" @click="changeTab('/my','my')">
                                <a>{{ $t('m.my.nav[0]') }}</a>
                            </li>
                            <li class="ant-menu-item" :class="active == 'safe' ? 'ant-menu-item-selected' : ''" style="padding-left: 16px;" @click="changeTab('/safe','safe')">
                                <a>{{ $t('m.my.nav[1]') }}</a>
                            </li>
                            <li class="ant-menu-item" :class="active == 'realname' ? 'ant-menu-item-selected' : ''" style="padding-left: 16px;" @click="changeTab('/realname','realname')">
                                <a>{{ $t('m.my.nav[2]') }}</a>
                            </li>
                            <!--<li class="ant-menu-item" :class="active == 'information' ? 'ant-menu-item-selected' : ''" style="padding-left: 16px;" @click="changeTab('/information','information')">-->
                            <!--<a>基本资料</a>-->
                            <!--</li>-->
                            <li class="ant-menu-item" :class="active == 'api' ? 'ant-menu-item-selected' : ''" style="padding-left: 16px;" @click="changeTab('/api','api')">
                                <a>{{ $t('m.my.nav[3]') }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="content_main">
                    <div class="ant-card ant-card-bordered ant-card-wider-padding" style="padding-bottom: 120px;">
                        <div class="ant-card-head">
                            <div class="ant-card-head-wrapper">
                                <div class="ant-card-head-title">{{ $t('m.my.nav[1]') }}</div>
                            </div>
                        </div>
                        <div class="ant-card-body">
                            <p class="securityAlert___3JPDX">{{ $t('m.my.safe.hint') }}</p>
                            <div class="secOptItem___2TQ10">
                                <div class="secOptItemLeft___1heNt">
                                    <img src="@/assets/img/yaoshi.png" alt="" class="secIcon___2-4NN">
                                </div>
                                <div class="secOptItemCenter___2AcAT">
                                    <p class="secName___3tgtm">
                                        <span>{{ $t('m.login.login.pwd[0]') }}</span>
                                    </p>
                                </div>
                                <div class="secOptItemRight___1X-bF">
                                    <div class="secTipContainer___1PSYG">
                                        <p class="secTip___vvbcR">
                                            <img src="@/assets/img/gou.svg" alt="" class="staIcon___2DISK">
                                            <span>{{ $t('m.my.safe.bind.effect[0]') }}</span>
                                        </p>
                                    </div>
                                    <p class="secBtn___23H1R">
                                        <a @click="changeRoute('/login_pwd')">{{ $t('m.my.safe.bind.handle[1]') }}</a>
                                    </p>
                                </div>
                            </div>
                            <div class="secOptItem___2TQ10">
                                <div class="secOptItemLeft___1heNt">
                                    <img src="@/assets/img/google.png" alt="" class="secIcon___2-4NN">
                                </div>
                                <div class="secOptItemCenter___2AcAT">
                                    <p class="secName___3tgtm">
                                        <span>{{ $t('m.my.index.bind[4]') }}</span>
                                    </p>
                                </div>
                                <div class="secOptItemRight___1X-bF">
                                    <div class="secTipContainer___1PSYG">
                                        <p class="secTip___vvbcR">
                                            <img src="@/assets/img/gou.svg" alt="" class="staIcon___2DISK" v-if="userInfo.isGoogle != 0">
                                            <img src="@/assets/img/cha.svg" alt="" class="staIcon___2DISK" v-else>
                                            <span>{{ $t('m.my.safe.bind.effect[1]') }}</span>
                                        </p>
                                    </div>
                                    <p class="secBtn___23H1R">
                                        <a @click="changeRoute('/my/google')" v-if="userInfo.isGoogle != 0">{{ $t('m.my.safe.bind.handle[1]') }}</a>
                                        <a @click="changeRoute('/my/google')" v-else>{{ $t('m.my.safe.bind.handle[0]') }}</a>
                                    </p>
                                </div>
                            </div>
                            <div class="secOptItem___2TQ10">
                                <div class="secOptItemLeft___1heNt">
                                    <img src="@/assets/img/shouji.png" alt="" class="secIcon___2-4NN">
                                </div>
                                <div class="secOptItemCenter___2AcAT">
                                    <p class="secName___3tgtm">
                                        <span>{{ $t('m.my.index.bind[3]') }}</span>
                                    </p>
                                </div>
                                <div class="secOptItemRight___1X-bF">
                                    <div class="secTipContainer___1PSYG">
                                        <p class="secTip___vvbcR">
                                            <img src="@/assets/img/gou.svg" alt="" class="staIcon___2DISK" v-if="userInfo.mobile">
                                            <img src="@/assets/img/cha.svg" alt="" class="staIcon___2DISK" v-else>
                                            <span>{{ $t('m.my.safe.bind.effect[2]') }}</span>
                                        </p>
                                    </div>
                                    <p class="secBtn___23H1R">
                                        <a @click="changeRoute('/new_phone')" v-if="userInfo.mobile">{{ $t('m.my.safe.bind.handle[1]') }}</a>
                                        <a @click="changeRoute('/new_phone')" v-else>{{ $t('m.my.safe.bind.handle[0]') }}</a>
                                    </p>
                                </div>
                            </div>
                            <div class="secOptItem___2TQ10">
                                <div class="secOptItemLeft___1heNt">
                                    <img src="@/assets/img/youjian.png" alt="" class="secIcon___2-4NN">
                                </div>
                                <div class="secOptItemCenter___2AcAT">
                                    <p class="secName___3tgtm">
                                        <span>{{ $t('m.my.index.bind[2]') }}</span>
                                    </p>
                                </div>
                                <div class="secOptItemRight___1X-bF">
                                    <div class="secTipContainer___1PSYG">
                                        <p class="secTip___vvbcR">
                                            <img src="@/assets/img/gou.svg" alt="" class="staIcon___2DISK" v-if="userInfo.email != ''">
                                            <img src="@/assets/img/cha.svg" alt="" class="staIcon___2DISK" v-else>
                                            <span>{{ $t('m.my.safe.bind.effect[3]') }}</span>
                                        </p>
                                    </div>
                                    <p class="secBtn___23H1R">
                                        <a @click="changeRoute('/new_email')" v-if="userInfo.email != ''">{{ $t('m.my.safe.bind.handle[1]') }}</a>
                                        <a @click="changeRoute('/new_email')" v-else>{{ $t('m.my.safe.bind.handle[0]') }}</a>
                                    </p>
                                </div>
                            </div>
                            <div class="secOptItem___2TQ10">
                                <div class="secOptItemLeft___1heNt">
                                    <img src="@/assets/img/yaoshi.png" alt="" class="secIcon___2-4NN">
                                </div>
                                <div class="secOptItemCenter___2AcAT">
                                    <p class="secName___3tgtm">
                                        <span>{{ $t('m.my.index.bind[9]') }}</span>
                                    </p>
                                </div>
                                <div class="secOptItemRight___1X-bF">
                                    <div class="secTipContainer___1PSYG">
                                        <p class="secTip___vvbcR">
                                            <img v-if="!userInfo.dealpwd"
                                                    src="@/assets/img/cha.svg" alt="" class="staIcon___2DISK">
                                            <img v-else
                                                 src="@/assets/img/gou.svg" alt="" class="staIcon___2DISK">
                                            <span>{{ $t('m.my.safe.bind.effect[4]') }}</span>
                                        </p>
                                    </div>
                                    <p class="secBtn___23H1R">
                                        <a @click="changeRoute('/deal_pwd')" v-if="!userInfo.dealpwd">{{ $t('m.my.safe.bind.handle[0]') }}</a>
                                        <a @click="changeRoute('/deal_pwd')" v-else>{{ $t('m.my.safe.bind.handle[1]') }}</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Bottom></Bottom>
    </div>
</template>

<script>
    import Top from '@/components/top'
    import Bottom from '@/components/bottom'

    export default {
        name: "safe",
        components: {
            Top, Bottom
        },
        data() {
            return {
                active: 'safe'
            }
        },
        methods: {
            changeTab: function (url, path) {
                this.active = path;
                this.changeRoute(url);
            }
        }
    }
</script>

<style scoped>
    @import "../../../assets/css/safe.css";
</style>
